import { render, staticRenderFns } from "./tour.vue?vue&type=template&id=b72b9874&"
import script from "./tour.vue?vue&type=script&lang=ts&"
export * from "./tour.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports